var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.template)?_c('JSONTemplateTransactionGroupEditor',{attrs:{"template":_vm.template,"bound_variables":{cidr_base: _vm.cidr, is_reserved: true, is_dhcp: false},"modal_id":_vm.modal_id,"old_uuid":null}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }